import { IconProps } from '@/components/Icon';

export const IconTag = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 14 14' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.999975 7.00002L0.999975 6.99997L0.999975 3.00007C0.999975 1.8955 1.89541 1.00007 2.99998 1.00007L7.00009 1.00007C7.00012 1.00007 7.00016 1.00007 7.00019 1.00007C7.10311 1.00012 7.20469 1.0391 7.28282 1.11722L12.8828 6.71722C13.039 6.87343 13.039 7.1267 12.8828 7.28291L7.28282 12.8829C7.12661 13.0391 6.87334 13.0391 6.71713 12.8829L1.11713 7.28291C1.03894 7.20471 0.999963 7.10302 0.999975 7.00002ZM2.99998 4.20007C3.66272 4.20007 4.19998 3.66281 4.19998 3.00007C4.19998 2.33733 3.66272 1.80007 2.99998 1.80007C2.33723 1.80007 1.79998 2.33733 1.79998 3.00007C1.79998 3.66281 2.33723 4.20007 2.99998 4.20007Z'
        fill={color}
        stroke={color}
        strokeWidth='0.8'
      />
    </svg>
  );
};
